
<row class="align-items-center">
  Show:
  <button
      class="ml-2 btn btn-select compress dropdown-toggle input-color arrow"
      @click.stop="openContextMenu"
  >
    {{ filterButtonText }}
  </button>

  <context-menu
      ref="contextMenu"
      :state="modalStateFor(vueModalID.filterPermissionPermitteesMenu)"
      :index="vueModalID.filterPermissionPermitteesMenu"
      fixed
      @close="closeContextMenu"
  >
    <ul class="p-3 scroll-area" tabindex="-1" style="max-height: 221px;">
      <li>
        <input id="select_all" type="checkbox" @input="toggleAll" :checked="allChecked">
        <label for="select_all">All Groups and Users</label>
      </li>

      <li v-for="permittee in selectedObjectModel.permissionPermitteesArray" :key="permittee.client_id">
        <input
            type="checkbox"
            :id="permittee.client_id"
            @input="toggleFilterPermittee(permittee.client_id)"
            :checked="permitteeChecked(permittee.client_id)"
        >
        <label :for="permittee.client_id">{{ permittee.display }}</label>
      </li>
    </ul>
  </context-menu>
</row>
